import React from 'react';

interface FilePreviewProps {
  files: File[];
  imageDataList: string[];
  onRemove: (index: number) => void;
  addToProject?: boolean[];
  onToggleAddToProject?: (index: number) => void;
}

const FilePreview: React.FC<FilePreviewProps> = ({
  files,
  imageDataList,
  onRemove,
  addToProject = [],
  onToggleAddToProject,
}) => {
  if (!files || files.length === 0) {
    return null;
  }

  // Compact ChatGPT/Claude-style image chips. Rendered as a fragment so they
  // sit alongside the brochure chip in the composer's attachments row (see
  // ChatBox) — no card chrome. Remove (×) floats top-right; the Dunea-specific
  // "add to project" toggle is a compact corner button.
  return (
    <>
      {files.map((file, index) =>
        imageDataList[index] ? (
          <div key={file.name + file.size} className="group relative flex-shrink-0">
            <img
              src={imageDataList[index]}
              alt={file.name}
              className={`w-14 h-14 object-cover rounded-lg border border-hairline transition-all ${
                addToProject[index] ? 'ring-2 ring-accent' : ''
              }`}
            />
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="absolute top-1 right-1 z-10 w-5 h-5 rounded-full bg-black/80 border border-hairline flex items-center justify-center hover:bg-black transition-colors touch:w-7 touch:h-7 touch:top-0.5 touch:right-0.5"
              aria-label="Remove image"
            >
              <div className="i-ph:x w-3 h-3 text-gray-200" />
            </button>
            {onToggleAddToProject && (
              <button
                type="button"
                onClick={() => onToggleAddToProject(index)}
                title={addToProject[index] ? 'In project' : 'Add to project'}
                aria-label={addToProject[index] ? 'Remove from project' : 'Add to project'}
                className={`absolute bottom-1 left-1 z-10 w-5 h-5 rounded-full bg-black/80 border flex items-center justify-center transition-colors touch:w-7 touch:h-7 touch:bottom-0.5 touch:left-0.5 ${
                  addToProject[index]
                    ? 'text-accent border-accent/50'
                    : 'text-gray-300 border-hairline hover:text-white'
                }`}
              >
                <div className={`w-3 h-3 ${addToProject[index] ? 'i-ph:folder-plus-fill' : 'i-ph:folder-plus'}`} />
              </button>
            )}
          </div>
        ) : null,
      )}
    </>
  );
};

export default FilePreview;
